import React, { memo, useCallback, useMemo } from 'react';
import {
  Box,
  Icon,
  Typography,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';

import { useAppointments } from '../../context';
import useStyles from './styles';

const Steps = ({ className }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const {
    newApppointmentStep: activeStep,
    newAppointmentResult,
  } = useAppointments();

  const getStatus = useCallback(
    order => {
      if (order === activeStep) {
        if (newAppointmentResult === 'SUCCESS') {
          return {
            status: 'COMPLETED',
            statusClass: 'completed',
          };
        }
        if (newAppointmentResult === 'ERROR') {
          return {
            status: 'ERROR',
            statusClass: 'error',
          };
        }
        return {
          status: 'ACTIVE',
          statusClass: 'active',
        };
      }
      if (order < activeStep) {
        return {
          status: 'COMPLETED',
          statusClass: 'completed',
        };
      }
      return {
        status: 'DISABLED',
        statusClass: 'disabled',
      };
    },
    [activeStep, newAppointmentResult],
  );

  const steps = useMemo(
    () => [
      { order: 1, name: 'Horário', ...getStatus(1) },
      { order: 2, name: 'Informações', ...getStatus(2) },
      { order: 3, name: 'Confirmação', ...getStatus(3) },
    ],
    [getStatus],
  );

  return (
    <Box className={`${classes.container} ${className}`}>
      {steps.map(step => (
        <Box key={step.order} className={`step-container ${step.statusClass}`}>
          <Box className="step-circle-container">
            {step.status === 'COMPLETED' || step.status === 'ERROR' ? (
              <Icon
                className="step-circle-icon"
                color="inherit"
                fontSize={isLargeScreen ? 'default' : 'small'}
              >
                {step.status === 'COMPLETED' && 'check'}
                {step.status === 'ERROR' && 'priority_high'}
              </Icon>
            ) : (
              <Typography className="step-circle-text" variant="subtitle2">
                {step.order}
              </Typography>
            )}
          </Box>
          <Typography className="step-name" variant="caption">
            {step.name}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default memo(Steps);
